import Image from '@/components/ui/Image';

export function PrimitivaIcon() {
  return (
    <Image 
      src="/images/primitiva.svg" 
      alt="Título Primitiva" 
      width={32} 
      height={32} 
      className="drop-shadow-md"
    />
  );
}
